import { render, staticRenderFns } from "./CollapseComponent.vue?vue&type=template&id=2e6266d8&scoped=true&"
import script from "./CollapseComponent.vue?vue&type=script&lang=js&"
export * from "./CollapseComponent.vue?vue&type=script&lang=js&"
import style0 from "./CollapseComponent.vue?vue&type=style&index=0&id=2e6266d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6266d8",
  null
  
)

export default component.exports